export const sanitizeUnits = (units) => {
  return units?.filter((unit) => {
    return unit && unit?.name
  })
}

export const sanitizeUnitGroups = (groups) => {
  return groups.map((group) => {
    return {
      ...group,
      units: group.units?.filter((unit) => unit && unit?.name),
    }
  })
}
